const AbiActivityLogApiUrls = {
  LIST: `${process.env.REACT_APP_USER_ABI_URL}/abi/activity-log/list`,
  GET_BY_ID: `${process.env.REACT_APP_USER_ABI_URL}/abi/activity-log`,
};

export default AbiActivityLogApiUrls;
